import type { AnimationDataV10 } from './types/v10';
import type { AnimationDataV11 } from './types/v11';

/**
 * V10 → V11. Pure type widening: `AnimationData` gains an optional `sceneShots`
 * map (luminary scene id → shot id) for videos edited scene by scene in the
 * creator. Every V10 blob is structurally a V11 blob — just bump the version.
 */
export function v10ToV11(input: AnimationDataV10): AnimationDataV11 {
    return { ...input, version: 11 };
}
